import React, { lazy, Suspense } from 'react';
import { Title } from '@landing/ui';
import Projects from 'components/Projects';
import { useIsSsr } from 'utils/hooks';

import * as styles from './About.module.scss';

const Animation = lazy(() => import('components/UI/Animation'));

export default function About({ title, items, projects }) {
  const isSsr = useIsSsr();
  return (
    <div className={styles.animationWrapper}>
      <section id="about" className={styles.layout}>
        <Title className={styles.title} color="white">
          {title}
        </Title>
        <div className={styles.content}>
          {items.map(({ number, description }, i) => (
            <div key={i} className={styles.item}>
              <div className={styles.itemNumber}>{number}</div>
              <p className={styles.itemDescription}>{description}</p>
            </div>
          ))}
        </div>
        {!isSsr && (
          <Suspense fallback={null}>
            <Animation preserveAspectRatio className={styles.animation} name="about" />
          </Suspense>
        )}
      </section>
      <Projects {...projects} />
    </div>
  );
}
